<template>
  <v-container grid-list-lg>
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-layout>
        <edit-actions
          v-if="actionsEdit"
          @change="changeDisplay"
          @save="save"
          :valid="valid"
          :displayMode="isDisplayMode">
        </edit-actions>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm12 class="px-0">
          <display-field
            v-if="isDisplayMode"
            :value="items.agreement"
            label="Contrato">
          </display-field>
          <v-text-field
            v-else
            label="Contrato"
            v-model="dataItems.agreement"
            :rules="validate.requiredRules"
            required
            :disabled="isDisabled"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm12 class="px-0">
          <display-field
            v-if="isDisplayMode"
            :value="items.cardNumber"
            label="Cartão">
          </display-field>
          <v-text-field
            v-else
            label="Cartão"
            v-model="dataItems.cardNumber"
            :rules="validate.requiredRules"
            required
            :disabled="isDisabled"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm12 class="px-0">
          <display-field
            v-if="isDisplayMode"
            :value="items.code"
            label="Código Administrativo">
          </display-field>
          <v-text-field
            v-else
            label="Código Administrativo"
            v-model="dataItems.code"
            :rules="validate.requiredRules"
            required
            :disabled="isDisabled"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import mixin from './mixin'
export default {
  mixins: [ mixin ]
}
</script>

